import { render, staticRenderFns } from "./TableShowB.vue?vue&type=template&id=77d66e3c&scoped=true"
import script from "./TableShowB.vue?vue&type=script&lang=js"
export * from "./TableShowB.vue?vue&type=script&lang=js"
import style0 from "./TableShowB.vue?vue&type=style&index=0&id=77d66e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d66e3c",
  null
  
)

export default component.exports